import { lazy, Suspense, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useParams } from 'react-router-dom';
import { trackEvent } from '../../../../analytics/consent';
import { getFindGravePath } from '@/service/constants';
import styles from './HomepageFindGraveFirst.module.css';

const HomepageFindGraveLandingSearch = lazy(() => import('./HomepageFindGraveLandingSearch'));

const HomepageFindGraveFirst = ({ municipalityName, cemeteryName, municipalityCount, ...props }) => {
  const { municipality, cemetery } = useParams();

  useEffect(() => {
    if (!municipality) return;
    trackEvent('municipality_browsed', {
      name: municipalityName || municipality,
      count: typeof municipalityCount === 'number' ? municipalityCount : null,
    });
  }, [municipality, municipalityCount, municipalityName]);

  const municipalityLabel = municipalityName || municipality;

  if (municipality && !cemetery) {
    return (
      <div className={styles.headerWrapper}>
        <div className={styles.breadcrumbs}>
          <Link to={getFindGravePath()}>
            <FormattedMessage id="find_grave" />
          </Link>
          /<span>{municipalityName}</span>
        </div>
        <p className={styles.contextStatement}>
          <FormattedMessage id="find_grave_practical_reason" values={{ municipalityName: municipalityLabel }} />
        </p>
      </div>
    );
  }

  if (municipality && cemetery) {
    return (
      <div className={styles.headerWrapper}>
        <div className={styles.breadcrumbs}>
          <Link to={getFindGravePath()}>
            <FormattedMessage id="find_grave" />
          </Link>
          /<Link to={`${getFindGravePath()}/${municipality}`}>{municipalityName}</Link> /{' '}
          <Link to={`${getFindGravePath()}/${municipality}/${cemetery}`}>{cemeteryName}</Link>
        </div>
        <p className={styles.contextStatement}>
          <FormattedMessage
            id="find_grave_cemetery_practical_reason"
            values={{
              cemeteryName: cemeteryName || cemetery,
              municipalityName: municipalityLabel,
            }}
          />
        </p>
      </div>
    );
  }

  return (
    <Suspense fallback={<div className={styles.homepageFindGraveFirst} />}>
      <HomepageFindGraveLandingSearch {...props} />
    </Suspense>
  );
};

export default HomepageFindGraveFirst;
